import { render, staticRenderFns } from "./LocalAreaDataTable.vue?vue&type=template&id=5cab8f06&scoped=true&"
import script from "./LocalAreaDataTable.vue?vue&type=script&lang=js&"
export * from "./LocalAreaDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab8f06",
  null
  
)

export default component.exports